// dependencies imports
import React, { useRef, useState, useEffect } from "react";
import Popover from "react-popover";

// assets and scss imports
import "./collectionSummaryTableView.scss";
import info_icon from "../../../../assets/dashboard/info_icon.svg";
import NoDataFound from "../../../../assets/Nodata.svg";

// project file imports
// constants imports
import { COLLECTION_SUMMARY_TABLE_HEADER } from "../../constants";
import { formatDecimalNumber } from "../../../../Util/Helper/formatNumberWithDecimals";

const CollectionSummaryTableView = ({
  showFlag,
  collectionSummary,
  totalSummaryAmount,
}) => {
  const [popoverId, setPopoverId] = useState("");
  const tbodyRef = useRef(null);

  const handlePopoverOpen = (id) => {
    setPopoverId(id);
  };
  const handlePopoverClose = () => {
    setPopoverId("");
  };

  const displayHoverContent = (msg) => {
    return <div style={{ padding: "6px 10px", fontSize: "12px" }}>{msg}</div>;
  };

  const displayHyphen = () => {
    return <span className="cstv-hypen">-</span>;
  };

  const getSummaryAmountDetails = (item, summaryData) => {
    switch (item?.name?.toLowerCase()) {
      case "cash":
        return summaryData?.total_cash_amount
          ? `₹${formatDecimalNumber(summaryData?.total_cash_amount)}`
          : displayHyphen();
      case "c2c online":
        return summaryData?.total_online_amount
          ? `₹${formatDecimalNumber(summaryData?.total_online_amount)}`
          : displayHyphen();
      case "others":
        return summaryData?.total_other_amount
          ? `₹${formatDecimalNumber(summaryData?.total_other_amount)}`
          : displayHyphen();
      case "total":
        return summaryData?.total_calculated_amount
          ? `₹${formatDecimalNumber(summaryData?.total_calculated_amount)}`
          : displayHyphen();
      default:
        return displayHyphen();
    }
  };

  const getTotalSummaryAmount = (item, totalSummaryAmount) => {
    switch (item?.name?.toLowerCase()) {
      case "cash":
        return totalSummaryAmount?.sum_of_cash
          ? `₹${formatDecimalNumber(totalSummaryAmount?.sum_of_cash)}`
          : displayHyphen();
      case "c2c online":
        return totalSummaryAmount?.sum_of_online_amount
          ? `₹${formatDecimalNumber(totalSummaryAmount?.sum_of_online_amount)}`
          : displayHyphen();
      case "others":
        return totalSummaryAmount?.sum_of_other_amount
          ? `₹${formatDecimalNumber(totalSummaryAmount?.sum_of_other_amount)}`
          : displayHyphen();
      case "total":
        return totalSummaryAmount?.sum_of_total_calculated_amount
          ? `₹${formatDecimalNumber(
              totalSummaryAmount?.sum_of_total_calculated_amount
            )}`
          : displayHyphen();
      default:
        return displayHyphen();
    }
  };

  const displayTableMobileUI = () => {
    return (
      <div className={`cstv-mobile-ui ${showFlag && "cstv-mobile-ui-border"}`}>
        {showFlag && (
          <>
            {collectionSummary.map((data, dataIndex) => (
              <div className="cstv-mui-box" key={dataIndex}>
                <h4>{data?.user_name}</h4>
                <div className="cstv-mui-box-body">
                  {COLLECTION_SUMMARY_TABLE_HEADER.slice(1)?.map(
                    (item, indx) => (
                      <div key={indx}>
                        <p className="cstv-mui-label">
                          {item?.name}{" "}
                          {item.hoverMsg && (
                            <Popover
                              isOpen={popoverId === dataIndex ? true : false}
                              preferPlace={`below`}
                              place={null}
                              body={displayHoverContent(item.hoverMsg)}
                            >
                              <img
                                src={info_icon}
                                className="cstv-cursor"
                                alt=""
                                onMouseOver={() => {
                                  handlePopoverOpen(dataIndex);
                                }}
                                onMouseOut={handlePopoverClose}
                              />
                            </Popover>
                          )}
                        </p>
                        <p className="cstv-mui-value">
                          {getSummaryAmountDetails(item, data)}
                        </p>
                      </div>
                    )
                  )}
                </div>
              </div>
            ))}
          </>
        )}

        <div className="cstv-mui-box footer">
          <h4>Total amount:</h4>
          <div className="cstv-mui-box-body">
            {COLLECTION_SUMMARY_TABLE_HEADER.slice(1)?.map((item, index) => (
              <div key={index}>
                <p className="cstv-mui-label">{item?.name} </p>
                <p className="cstv-mui-value">
                  {getTotalSummaryAmount(item, totalSummaryAmount)}
                </p>
              </div>
            ))}
          </div>
        </div>
      </div>
    );
  };

  const displayTableUI = () => {
    let containerBody = document.getElementById("cstv-table-body-scroll");
    let hasScroll = containerBody?.scrollHeight > containerBody?.clientHeight;
    return (
      <>
        <table>
          <div
            className={
              "cstv-table-header " + (!hasScroll ? "cstv-remove-padding" : "")
            }
          >
            <thead>
              <tr>
                {COLLECTION_SUMMARY_TABLE_HEADER?.map((item, index) => (
                  <th className={item?.className} key={index}>
                    {item.name}{" "}
                    {item.hoverMsg && (
                      <Popover
                        isOpen={popoverId === index ? true : false}
                        preferPlace={`below`}
                        place={null}
                        body={displayHoverContent(item.hoverMsg)}
                      >
                        <img
                          src={info_icon}
                          className="cstv-cursor"
                          alt=""
                          onMouseOver={() => {
                            handlePopoverOpen(index);
                          }}
                          onMouseOut={handlePopoverClose}
                        />
                      </Popover>
                    )}
                  </th>
                ))}
              </tr>
            </thead>
          </div>
          {collectionSummary?.length > 0 && (
            <>
              <div
                className={
                  "cstv-table-body " + (!hasScroll ? "cstv-remove-padding" : "")
                }
              >
                <div
                  className={
                    "table-body-wrapper " +
                    (!hasScroll ? "cstv-remove-padding" : "")
                  }
                  id="cstv-table-body-scroll"
                  ref={tbodyRef}
                >
                  <tbody>
                    {collectionSummary.map((data, index) => (
                      <tr key={index}>
                        <td className="cstv-username">{data?.user_name}</td>
                        <td className="cstv-cash">
                          {data?.total_cash_amount ? (
                            `₹${formatDecimalNumber(data?.total_cash_amount)}`
                          ) : (
                            <>&nbsp;&nbsp;-</>
                          )}
                        </td>
                        <td className="cstv-online">
                          {data?.total_online_amount
                            ? `₹${formatDecimalNumber(
                                data?.total_online_amount
                              )}`
                            : displayHyphen()}
                        </td>
                        <td className="cstv-others">
                          {data?.total_other_amount
                            ? `₹${formatDecimalNumber(
                                data?.total_other_amount
                              )}`
                            : displayHyphen()}
                        </td>
                        <td className={`cstv-total`}>
                          {data?.total_calculated_amount
                            ? `₹${formatDecimalNumber(
                                data?.total_calculated_amount
                              )}`
                            : displayHyphen()}
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </div>
              </div>
              <div
                className={
                  "cstv-table-footer " +
                  (!hasScroll ? "cstv-remove-padding" : "")
                }
              >
                <tfoot>
                  <tr>
                    <th className="cstv-username"></th>
                    <th className="cstv-cash">
                      {totalSummaryAmount?.sum_of_cash
                        ? `₹${formatDecimalNumber(
                            totalSummaryAmount?.sum_of_cash
                          )}`
                        : displayHyphen()}
                    </th>
                    <th className="cstv-online">
                      {totalSummaryAmount?.sum_of_online_amount
                        ? `₹${formatDecimalNumber(
                            totalSummaryAmount?.sum_of_online_amount
                          )}`
                        : displayHyphen()}
                    </th>
                    <th className="cstv-others">
                      {totalSummaryAmount?.sum_of_other_amount
                        ? `₹${formatDecimalNumber(
                            totalSummaryAmount?.sum_of_other_amount
                          )}`
                        : displayHyphen()}
                    </th>
                    <th className="cstv-total">
                      {totalSummaryAmount?.sum_of_total_calculated_amount
                        ? `₹${formatDecimalNumber(
                            totalSummaryAmount?.sum_of_total_calculated_amount
                          )}`
                        : displayHyphen()}
                    </th>
                  </tr>
                </tfoot>
              </div>
            </>
          )}
        </table>
        {collectionSummary?.length === 0 && (
          <div className="cstv-table-no-data">{displayNoDataFound()}</div>
        )}
      </>
    );
  };

  const displayNoDataFound = () => {
    return (
      <div className="cstv-no-data-found">
        <div>
          <img src={NoDataFound} alt="noData" className="no-data" />
        </div>
        <div style={{ marginTop: 15 }}>
          <span
            style={{
              fontWeight: "bold",
              fontSize: 15,
              color: "#1B2027",
              textAlign: "center",
            }}
          >
            No Record Found
          </span>
        </div>
        <span style={{ fontSize: 12, color: "#707070", textAlign: "center" }}>
          There are no appointments available
        </span>
      </div>
    );
  };

  return (
    <div className="collection-summary-table-view">
      {window.innerWidth > 768 ? (
        <>{showFlag && displayTableUI()}</>
      ) : (
        <>{displayTableMobileUI()}</>
      )}
    </div>
  );
};

export default CollectionSummaryTableView;
